import React from 'react';
import PreferenceContext from '../VideoPreferenceContex';

export default function VideoPreferenceProvider(props) {
  const { children } = props;
  return <PreferenceContext.Provider>{children}</PreferenceContext.Provider>;
}
